<template>
    <div class="hover__container">
        <span class="hover__content">
            {{content}}
        </span>
    </div>
</template>
<script>
    export default {
        props: ['content'],
        setup(){

        }
    }
</script>
<style lang="scss" scoped>
@import '@/styles/main.scss';

.hover{
    &__container{
        padding: 12px;
        color: #fff;
        background-color: $green;
        max-width: 275px;
        border-radius: 10px;
    }
    &__content{
        @media screen and (max-width: 860px){
            font-size: 12px;
        }
    }
}

</style>